import React from 'react'
import classes from './filter-button.module.scss';

const FilterButton = ({title, onDelete}) =>{
    return (
        <div className={classes.FilterButton}>
        <button  href="#" onClick={onDelete}  className={classes.close}><img alt="" src={require("../../assets/img/close.svg")} /></button>
        { title }
        </div>
    );
}

export { FilterButton } ;